import { render, staticRenderFns } from "./RulesCards.vue?vue&type=template&id=d258f7c6&scoped=true&"
import script from "./RulesCards.vue?vue&type=script&lang=js&"
export * from "./RulesCards.vue?vue&type=script&lang=js&"
import style0 from "./RulesCards.vue?vue&type=style&index=0&id=d258f7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d258f7c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VIcon,VProgressLinear})
